import React from "react";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";

function MultistepProgressbar(props) {
  return (
    <ProgressBar
        percent={((props.step - 1) * 100)/6} //Increase here
        filledBackground="linear-gradient(to right, #e9bc55, #caa159)"
      >
        <Step transition="scale">
            {({ accomplished, currentStepIndex }) => (
                <div onClick={()=>props.setCurrentStepIndex(1)} className={`text-sm w-[20px] h-[20px] bg-[#caa159] rounded-full flex justify-center items-center cursor-pointer text-white ${accomplished ? "completed" : ""}`}>
                    1
                </div>
            )}
        </Step>
        <Step transition="scale">
            {({ accomplished, currentStepIndex }) => (
                <div onClick={()=>props.setCurrentStepIndex(2)} className={`text-sm w-[20px] h-[20px] bg-[#caa159] rounded-full flex justify-center items-center cursor-pointer text-white ${accomplished ? "completed" : ""}`}>
                    2
                </div>
            )}
        </Step>
        <Step transition="scale">
            {({ accomplished, currentStepIndex }) => (
                <div onClick={()=>props.setCurrentStepIndex(3)} className={`text-sm w-[20px] h-[20px] bg-[#caa159] rounded-full flex justify-center items-center cursor-pointer text-white ${accomplished ? "completed" : ""}`}>
                    3
                </div>
            )}
        </Step>
        <Step transition="scale">
            {({ accomplished, currentStepIndex }) => (
                <div onClick={()=>props.setCurrentStepIndex(4)} className={`text-sm w-[20px] h-[20px] bg-[#caa159] rounded-full flex justify-center items-center cursor-pointer text-white ${accomplished ? "completed" : ""}`}>
                    4
                </div>
            )}
        </Step>
        <Step transition="scale">
            {({ accomplished, currentStepIndex }) => (
                <div onClick={()=>props.setCurrentStepIndex(5)} className={`text-sm w-[20px] h-[20px] bg-[#caa159] rounded-full flex justify-center items-center cursor-pointer text-white ${accomplished ? "completed" : ""}`}>
                    5
                </div>
            )}
        </Step>
        <Step transition="scale">
            {({ accomplished, currentStepIndex }) => (
                <div onClick={()=>props.setCurrentStepIndex(6)} className={`text-sm w-[20px] h-[20px] bg-[#caa159] rounded-full flex justify-center items-center cursor-pointer text-white ${accomplished ? "completed" : ""}`}>
                    6
                </div>
            )}
        </Step>
        <Step transition="scale">
            {({ accomplished, currentStepIndex }) => (
                <div onClick={()=>props.setCurrentStepIndex(7)} className={`text-sm w-[20px] h-[20px] bg-[#caa159] rounded-full flex justify-center items-center cursor-pointer text-white ${accomplished ? "completed" : ""}`}>
                    7
                </div>
            )}
        </Step>
      </ProgressBar>
  )
}

export default MultistepProgressbar